<template>
  <DefaultLayout>
    <div slot="content">
      <template v-if="!loading">
        <template v-for="rq in linkedLoadedReq">
          <!-- <v-divider :key="rq.profile.id" class="mt-5 mb-3"></v-divider> -->
          <ProfileView
            :requestId="rq.profile.id"
            :requestLoad="rq"
            :propertyTabId="$route.query.propertyTabId"
            :propertyTabReference="$route.query.propertyTabReference"
            :key="rq.profile.id"
            class="mb-5"
          ></ProfileView>
        </template>
      </template>
      <template v-else>
        <v-skeleton-loader class="mx-auto" type="list-item-avatar, divider, list-item-three-line, card-heading, image"></v-skeleton-loader>        
      </template>
    </div>
  </DefaultLayout>
</template>

<script>

import { mapState } from 'vuex';
import DefaultLayout from '@/layouts/DefaultLayout';
import ProfileView from '@/components/ProfileView';

import {
  GET_REQUEST
} from '@/store/actions.type';

export default {
  name: 'profile-request',
  components: {
    DefaultLayout,
    ProfileView
  },
  data() {
    return {
      loading: false,
      requests: [],
      linkedLoadedReq: [],
      linkedRequests: [],
      linkedLoaded: false,
      linkedloading: false
    };
  },
  computed: {
    ...mapState({ organization: state => state.organizations.userSelectedOrganization }),
    requestId() {
      return this.$route.params.id;
    },
  },
  watch:{
  },
  async mounted() {
    this.loading = true;
    try {
      for await (var req of this.requestId.split(',').map(rq => this.$store.dispatch(GET_REQUEST, rq))){
        if(req.profile.status === 8 && !this.organization.purgedRequests){
          continue;
        }
        else{
          this.linkedLoadedReq.push(req);
        }        
      }
      this.loading = false;
    } catch(err) {
      this.$notify({
        type: 'error',
        title: 'Error',
        text: 'Error loading request data. Please contact support@planetverify.com',
      });
      this.loading = false;
    }
  },
};
</script>
